import { Dispatch } from 'react';
import { TServiceClientActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_SERVICE_CLIENTS } from '../constants/actions';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { TAPIOptions } from 'src/constants/apis/types';

const SERVICE_LEAD_TYPE = 'service';

export const searchServiceClientsByFilters = async (
    dispatch: Dispatch<TServiceClientActionTypes>,
    filters: Record<string, unknown>,
    options: TAPIOptions = {
        isReadPermissionNecessary: false,
        select: '',
        populate: [],
    }
) => {
    dispatch({ type: SET_LOADING });
    const payload = { ...filters, type: SERVICE_LEAD_TYPE };
    try {
        const res = await ApiV2.post(
            '/service-clients/search',
            payload,
            HEADERS({
                isReadPermissionNecessary:
                    options.isReadPermissionNecessary ?? false,
            })
        );
        const results =
            res.data.results;
        const total = res.data.pagination.total || 0;
        dispatch({
            type: GET_SERVICE_CLIENTS,
            payload: results,
            total,
        });
    } catch (error) {
        dispatch({
            type: GET_SERVICE_CLIENTS,
            payload: [],
            total: 0,
        });
        if (error instanceof Error) dispatch(handleError(error));
    }
};
